import { useApi } from '@hero/context';
import type { UseEntityDirectorySearchApi } from './types';
import { useQueryAPI } from '../../utils';

/**
 * Unified Profile + Org picker search (relations-v2). Returns hits
 * already deduplicated server-side (a Profile carrying
 * `linkedOrgId` matching an Org hit is collapsed into a single row
 * carrying both ids). Disabled while the query string is empty so
 * the picker doesn't fire on first mount.
 *
 * Hook API: {@link UseEntityDirectorySearchApi}.
 */
export const useEntityDirectorySearchApi: UseEntityDirectorySearchApi = (
  query,
  apiConfig,
) => {
  const api = useApi();
  return useQueryAPI({
    entity: 'entityDirectory',
    apiFn: api.entityDirectory.search,
    query,
    apiConfig,
    isEnabled: () => Boolean(query.q && query.q.trim().length > 0),
  });
};
